import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import theme from '~/style/theme'

import Lock from '~/components/svg/Lock'

const ButtonContainer = styled.div`
  width: 220px;
  max-width: 100%;
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: ${props => props.theme.fonts.avenirNextMedium};
`

const Button = styled.button`
  width: 100%;
  height: 60px;
  font-size: 1.125rem;
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  border: none;
  user-select: none;
  outline: none;
  transition: all 0.5s ease;
  cursor: ${props => (props.isNotReady ? 'not-allowed' : 'pointer')};
  color: ${props => (props.isNotReady ? props.theme.colors.success : 'white')};
  background-color: ${props =>
    props.isNotReady ? 'white' : props.theme.colors.success};
  box-shadow: ${props =>
    props.isNotReady
      ? `0 9px 24px 0 rgba(35,41,48,0.15)`
      : `0 14px 24px 0 rgba(98,211,109,0.39)`};
  transform: scale(1, 1);
  :focus {
    box-shadow: 0 14px 24px 0 rgba(98, 211, 109, 0.59);
    transform: scale(0.95, 0.95);
  }
`

const SubText = styled.div`
  user-select: none;
  font-size: 1rem;
  margin-top: 10px;
  color: ${props => props.theme.colors.text.label};
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
`

const IconContainer = styled.div`
  margin-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 0;
  flex-shrink: 0;
`

const BigCheckoutButton = ({ id, allowSubmit, disabled, onClick, text }) => {
  const lockColor = allowSubmit ? '#FFFFFF' : theme.colors.success

  return (
    <ButtonContainer>
      <Button id={id} disabled={disabled} isNotReady={!allowSubmit} onClick={onClick}>
        <IconContainer>
          <Lock color={lockColor} />
        </IconContainer>
        {(allowSubmit && disabled) ? 'Please wait...' : text}
      </Button>
      <SubText>Secure Payment</SubText>
    </ButtonContainer>
  )
}

BigCheckoutButton.defaultProps = {
  disabled: false,
  text: 'Pay'
}

BigCheckoutButton.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string
}

export default BigCheckoutButton
